<!--
 * @Author: your name
 * @Date: 2020-09-08 09:37:08
 * @LastEditTime: 2022-10-20 17:18:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\accountConfirm\historyList.vue
-->
<template>
    <div class="accountConfirm-list">
        <van-nav-bar
            title="历史账务列表"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <van-search v-model="searchValue" placeholder="请输入搜索信息" @change="search"></van-search>
        <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
        >
            <template>
                <div class="warpper">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                    >
                        <div
                            class="materialPlan-item"
                            v-for="(item,index) in orderList"
                            :key="index"
                        >
                            <div :class="getClass(item.approval_status_name)">
                                {{ item.approval_status_name }}
                            </div>
                            <ul @click="toDetail(item)">
                                <li class="tit">
                                    <span class="iconfont icondanjubianhao"></span>
                                    <span class="info">收款编号：{{ item.proceeds_number }}</span>
                                </li>
                                <li>
                                    <span class="pre-icon materialPlan02"></span>
                                    <span class="info">合同编号：{{ item.contract_number }}</span>
                                </li>
                                <li>
                                    <span class="pre-icon materialPlan01"></span>
                                    <span class="info">客户名称：{{ item.client_name }}</span>
                                </li>

                                <li>
                                    <span class="pre-icon materialPlan03"></span>
                                    <span class="info">工程名称：{{ item.engineering_name }}</span>
                                </li>
                                <li>
                                    <span class="pre-icon materialPlan06"></span>
                                    <span class="info">结算周期开始时间：{{ item.settlement_start_time }}</span>
                                </li>
                                <li>
                                    <span class="pre-icon materialPlan06"></span>
                                    <span class="info">结算周期结束时间：{{ item.settlement_end_time }}</span>
                                </li>
                                <li>
                                    <van-row>
                                        <van-col span="12">
                                            <span class="pre-icon materialPlan07"></span>
                                            <span class="info">期初应收：{{ item.Initial_receivables }}</span>
                                        </van-col>
                                        <van-col span="12">
                                            <span class="pre-icon materialPlan07"></span>
                                            <span class="info">期末应收余额：{{ item.ending_balance_receivable }}</span>
                                        </van-col>
                                    </van-row>
                                </li>
                                <li>
                                    <van-row>
                                        <van-col span="12">
                                            <span class="pre-icon materialPlan07"></span>
                                            <span class="info">本期应收：{{ item.loans_receivable }}</span>
                                        </van-col>
                                        <van-col span="12">
                                            <span class="pre-icon materialPlan07"></span>
                                            <span class="info">本期实收：{{ item.official_receipt }}</span>
                                        </van-col>
                                    </van-row>
                                </li>
                                <li>
                                    <span class="pre-icon materialPlan06"></span>
                                    <span class="info">收款日期：{{ item.receipt_date }}</span>
                                </li>
                            </ul>
                        </div>
                    </van-list>
                </div>
            </template>
        </van-pull-refresh>
    </div>
</template>

<script>
export default {
    name: 'account-confirm-history-list',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/accountConfirmList') {
            this.$store.commit('noKeepAlive', 'account-confirm-history-list');
        }
        next();
    },
    components: {},
    props: {},
    data() {
        return {
            // 合同编号
            contract_number: '',
            orderList: [],
            loading: false,
            finished: false,
            page: {
                pageindex: 0,
                pagesize: 3,
            },
            // 下拉刷新
            isLoading: false,
            // 查询条件
            searchValue: '',
        };
    },
    watch: {},
    computed: {},
    created() {
        this.contract_number = this.$route.params.contract_number;
    },
    mounted() {},
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 跳转到确认页面
        toDetail(data) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'accountConfirmInfo', params: { data: data } });
        },
        getClass(name) {
            let str = 'status ';
            if (name === '已提交') {
                str += 'status1';
            } else if (name === '未提交') {
                str += 'status0';
            } else if (name === '已确认') {
                str += 'status2';
            }
            return str;
        },
        // 下拉刷新
        onRefresh() {
            this.page.pageindex = 0;
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        // 条件查询
        search() {
            this.page.pageindex = 0;
            this.orderList = [];
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        onLoad() {
            if (this.isLoading) {
                this.orderList = [];
                this.isLoading = false;
            }
            this.page.pageindex += 1;
            this.getListPage();
        },
        async getListPage() {
            const res = await this.getHistoricalRecordsListApi();
            if (res) {
                this.showOverlay = false;
                this.loading = false;
                this.isLoading = false;
                if (res.total) {
                    this.total = true;
                    this.orderList = this.orderList.concat(res.rows);
                    if (this.orderList.length >= res.total) {
                        this.finished = true;
                    }
                } else {
                    this.total = false;
                    this.finished = true;
                }
            }
        },

        getHistoricalRecordsListApi() {
            // eslint-disable-next-line max-len
            const queryStr = `?contract_number=${this.contract_number}&pageindex=${this.page.pageindex}&pagesize=${this.page.pagesize}&keyword${this.searchValue}`;
            return this.$axios.$get('/interfaceApi/sale/accounts/get_proceeds_confirm_list_history' + queryStr, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.accountConfirm-list
    height 100%
    background #F0F0F0
    .van-pull-refresh
        height calc(100% - 90rpx)
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        .van-pull-refresh__track
            height 100%
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
    .van-overlay
        .van-loading
            position absolute
            z-index 100
            top 50%
            left 50%
    .newPlan
        position fixed
        right 20rpx
        top 10rpx
        z-index 1000
        color #fff
    .search-con
        .van-search
            padding 15rpx 12rpx 15rpx 12rpx
    .van-pull-refresh__head
        background #F0F0F0
    .warpper
        background #F0F0F0
        padding 12rpx 12rpx 12rpx 12rpx
        position relative
        .materialPlan-item
            width 100%
            background #ffffff
            margin-bottom 15rpx
            position relative
            overflow hidden
            color #666666
            font-size 14rpx
            .status
                position absolute
                right 5rpx
                top 15rpx
                &.status0
                    color #0101B5
                &.status1
                    color #00A84B
                &.status2
                    color #FF6600
            .connect
                position absolute
                bottom 70rpx
                right 15rpx
                padding 5rpx 15rpx
                border 1px solid #5588F1
                border-radius 4rpx
                color #5588F1
            ul
                padding 16rpx 16rpx 5rpx 16rpx
                border-bottom 1px solid #F0F0F0
                li
                    overflow hidden
                    margin-bottom 10rpx
                    .pre-icon
                        width 16rpx
                        height 16rpx
                        float left
                        background-size 100% 100%
                        background-repeat no-repeat
                        display inline-block
                        margin 2rpx 10rpx 0 0
                        &.materialPlan01
                            background-image url(./../../../assets/images/icons/icon_2.png)
                        &.materialPlan02
                            background-image url(./../../../assets/images/icons/icon_gy_8.png)
                        &.materialPlan03
                            background-image url(./../../../assets/images/icons/icon_gy_2.png)
                        &.materialPlan04
                            background-image url(./../../../assets/images/icons/icon_6.png)
                        &.materialPlan05
                            background-image url(./../../../assets/images/icons/icon_19.png)
                        &.materialPlan06
                            background-image url(./../../../assets/images/icons/icon_gy_7.png)
                        &.materialPlan07
                            background-image url(./../../../assets/images/icons/icon_26.png)
                    .info
                        float left
                        width calc(100% - 26rpx)
                    &.tit
                        font-size 16rpx
                        .icondanjubianhao
                            color #3495FB
                            font-size 18rpx
                            margin 3rpx 8rpx 0 0
                            float left
    .warpper-zcx
        padding 12rpx 12rpx 12rpx 12rpx

</style>